import { configValue } from 'config/appConfigUtils';

const getPostSearchIndex = () => configValue('algolia', 'contentIndexName');

// eslint-disable-next-line import/no-default-export
export default getPostSearchIndex;
